import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard, RoutingConfig, provideDefaultConfig } from '@spartacus/core';
import { CmsPageGuard, PRODUCT_LISTING_URL_MATCHER, PageLayoutComponent } from '@spartacus/storefront';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: null,
        canActivate: [CmsPageGuard, AuthGuard],
        component: PageLayoutComponent,
        data: { pageLabel: 'search', cxRoute: 'search' },
      },
      {
        path: null,
        canActivate: [CmsPageGuard, AuthGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'brand' },
      },
      {
        path: null,
        canActivate: [CmsPageGuard, AuthGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'category' },
      },
    ]),
  ],
  providers: [
    provideDefaultConfig(<RoutingConfig>{
      routing: {
        routes: {
          category: {
            matchers: [PRODUCT_LISTING_URL_MATCHER],
          },
        },
      },
    }),
  ],
})
export class CustomProductListingPageModule {}
